module.exports = __webpack_public_path__ + "static/media/polytechnic-campus.51d3657c.jxr";